import { SDrawer } from './Drawer.styles';
import { DrawerProps } from './Drawer.types';

export const Drawer = ({ ...props }: DrawerProps) => {
  return <SDrawer {...props} />;
};
